module.exports = __webpack_public_path__ + "static/media/1012734.3216bed3.jpg";